import React from "react";
import "./adpilot.css";
import NewFooter from "../../components/NewFooter/NewFooter";
import { Carousel } from "../../components/VerticalCarousel";
import img6 from "../../assets/adpilot/adpilot1.png";
import img7 from "../../assets/adpilot/adpilot2.png";
import img8 from "../../assets/adpilot/adpilot3.png";
import b1 from "../../assets/adpilot/adpilot6.png";
import b2 from "../../assets/adpilot/adpilot2-modified.png";
import b3 from "../../assets/adpilot/adpilot5-16-9-rectangle-modified.png";
import CardGrid from "../../components/productCardsGrid/productInfoCards";
import OverlayCard from "../../components/OverlayCard";

export default function Sara() {
  const cards=[
  {
    "title": "Group Recommendations",
    "description": "Seamlessly curates content tailored to the shared preferences of your group, ensuring everyone finds something they love."
  },
  {
    "title": "Smart Notifications",
    "description": "Keep users engaged with smart notifications, highlighting new releases or content they'll love, based on their preferences."
  },
  {
    "title": "Ad Ingestion Made Simple",
    "description": "Upload images, videos, or even GIFs. Whether it’s a banner, overlay, splash screen, or poster thumbnail — AdPilot adapts it for every platform."
  },
  {
    "title": "Cross-Platform, Cross-Format",
    "description": "From smart TVs to mobile OTT apps, AdPilot ensures seamless ad delivery without losing creative fidelity."
  },
  {
    "title": "Smart Decisioning",
    "description": "AdPilot’s AI mini-decision engine ensures ads reach the right audience at the right time and placement."
  },
  {
    "title": "Ad Analytics That Matter",
    "description": "Go beyond impressions. AdPilot provides insights into engagement, attention, conversions, and ROI with full transparency."
  }
]

  const whitepapers = [
    {
      id: 1,
      src: img6,
      alt: "image1 for carousel",
    },
    {
      id: 2,
      src: img7,
      alt: "image 2 for carousel",
    },
    {
      id: 3,
      src: img8,
      alt: "image 3 for carousel",
    },
  ];

  const blogs = [
    {
      id: "1",
      title: "Unified Dashboard",
      description:
        "All your Ads in one dashboard. Manage campaigns across Google, Facebook, Instagram, and more — all from a single, intuitive interface.",
      name: "",
      image: b1,
    },
    {
      id: "2",
      title: "Real-Time Optimization",
      description:
        "Optimize in real time. Get actionable insights and auto-optimize your ad performance on the fly, saving time and boosting ROI.",
      name: "",
      image: b2,
    },
    {
      id: "3",
      title: "Built for Marketers",
      description:
        "Built for Clarity, Speed, Performance. Designed for modern marketers who demand better tools to launch, track, and scale campaigns effortlessly.",
      name: "",
      image: b3,
    },
  ];

  const BlogCard = ({ title, description, name, image }) => (
    <div className="sara-styled-card">
      <img className="overlay-image" src={image} alt={title}  />
      <div className="card-content">
        <h5 className="title">{title}</h5>
        <p className="description">{description}</p>
        {/* <p className="author">Author: {name}</p> */}
      </div>
    </div>
  );

  return (
    <div style={{ background: "black" }}>
      <div className="sara-container">
        <div className="sara-first">
          <div className="logo">
            <img
              src={require("../../assets/products/HZAD.png")}
              alt="Adpilot Logo"
            />
          </div>
          <div className="sara-title">
            <h3>AdPilot</h3>
          </div>
          <div className="sara-des">
            <p>Create, Manage and Track your Ads</p>
            <p>
              Horizon’s Ad Management Software - Streamline campaigns, optimize
              performance, and scale your growth — all in one powerful platform.
            </p>
          </div>
          <div style={{display:"flex",flexDirection:"row",gap:"20px"}}>
            
              <OverlayCard  blogs={blogs} />
           
          </div>
        </div>
        <div className="insight">
          <div className="sara-carousel">
            <Carousel data={whitepapers} />
            <div className="cus-des">
              <div className="cus-title">
                <h3>AdPilot</h3>

<p style={{width: "30vw"}}>
  <strong>AdPilot</strong> is an advanced <strong>ad management platform</strong><br />
  built to streamline <strong>multi-channel advertising</strong>.<br /><br />

  Easily store creatives, manage <strong>audience segments</strong>,<br />
  and launch campaigns across <strong>OTT platforms</strong>,<br />
  <strong>CMS interfaces</strong>, and mobile apps.<br /><br />

  Gain <strong>real-time analytics</strong> and total control<br />
  from one intuitive dashboard.<br /><br />

  Designed for marketers who need<br />
  <strong>speed</strong>, <strong>scalability</strong>, and <strong>targeted performance</strong>.
</p>


              </div>
            </div>
          </div>
        </div>

        <div className="w-m-s-p">
          <div className="sara-title2">
            <h3>What makes AdPilot Special</h3>
          </div>
          <div className="features">
          </div>
          <div>
            <CardGrid cards={cards}/>
          </div>
        </div>
        
      </div>
      <NewFooter />
    </div>
  );
}
